module.exports = __webpack_public_path__ + "assets/img/concealtit.a4740dd1.png";